import { matchRoutes, useLocation } from 'react-router-dom';
import { getMainLayoutRoutes } from 'pages/layouts/mainLayoutRoutes';

// Resolves the current page's title from the matched route: breadcrumb titles joined with " - ",
// then the route's own title, then the raw pathname when the route provides neither.
export function usePageTitle() {
    const location = useLocation();
    const matches = matchRoutes(getMainLayoutRoutes(), location);

    if (matches == null || matches.length === 0) {
        return location.pathname;
    }

    const { breadcrumbs, title } = matches[matches.length - 1].route;
    const breadcrumbTitles = (breadcrumbs ?? [])
        .map((breadcrumb) => breadcrumb.title)
        .filter((breadcrumbTitle) => breadcrumbTitle != null && breadcrumbTitle.trim().length > 0);

    if (breadcrumbTitles.length > 0) {
        return breadcrumbTitles.join(" - ");
    }

    if (title != null) {
        return title;
    }

    return location.pathname;
}
